import script from "./HDFAuthHandle.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFAuthHandle.vue?vue&type=script&setup=true&lang=js"

import "./HDFAuthHandle.vue?vue&type=style&index=0&id=c33756ae&lang=css"

const __exports__ = script;

export default __exports__